import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';
import { ContactRequest } from '../contact-request';

@Component({
  selector: 'app-wp-contact-requests',
  templateUrl: './wp-contact-requests.component.html',
  styleUrls: ['./wp-contact-requests.component.css']
})
export class WpContactRequestsComponent implements OnInit {

  contactRequests: Observable<ContactRequest[]>;
  filteredRequests: Observable<ContactRequest[]>;
  filter: Observable<string>;
  searchForm: FormGroup;

  displayOptions = [
    { label: "Show all", value: 0 },
    { label: "New leads", value: 1 },
    { label: "Processed", value: 2 },
    { label: "Deleted", value: 3 }
  ];

  selectedDisplayOption = this.displayOptions[1].value;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder
  ) {
    this.contactRequests = this.httpService.getContactRequestNew();
    this.searchForm = this.builder.group({
      searchTerm: ""
    });
    this.filter = this.searchForm.get("searchTerm")!.valueChanges.pipe(startWith(""));
    this.filteredRequests = combineLatest([this.contactRequests, this.filter]).pipe(
      map(([requests, filterString]) => requests.filter(request => 
        (request.firstName != null && request.firstName.toLowerCase().indexOf(filterString.toLowerCase()) != -1) || 
        (request.lastName != null && request.lastName.toLowerCase().indexOf(filterString.toLowerCase()) != -1)
      )));
    this.contactRequests.subscribe(res => console.log(res));
   }

  ngOnInit(): void {}

  resetSearchBox(){
    this.searchForm.get("searchTerm")!.setValue("");
  }

  initFilter(){
    this.filteredRequests = combineLatest([this.contactRequests, this.filter]).pipe(
      map(([requests, filterString]) => requests.filter(request => 
        (request.firstName != null && request.firstName.toLowerCase().indexOf(filterString.toLowerCase()) != -1) || 
        (request.lastName != null && request.lastName.toLowerCase().indexOf(filterString.toLowerCase()) != -1)
      )));
  }

  getAll(){
    this.contactRequests = this.httpService.getContactRequests();
    this.resetSearchBox();
    this.initFilter();
  }

  getNewLeads(){
    this.contactRequests = this.httpService.getContactRequestNew();
    this.resetSearchBox();
    this.initFilter();
  }

  getProcessed(){
    this.contactRequests = this.httpService.getContactRequestProcessed();
    this.resetSearchBox();
    this.initFilter();
  }

  getDeleted(){
    this.contactRequests = this.httpService.getContactRequestDeleted();
    this.resetSearchBox();
    this.initFilter();
  }

  updateView() {
    if (this.selectedDisplayOption == 0) {
      this.getNewLeads();
    } else if (this.selectedDisplayOption == 1) {
      this.getNewLeads();
    } else if (this.selectedDisplayOption == 2) {
      this.getProcessed();
    } else if(this.selectedDisplayOption == 3){
      this.getDeleted();
    }
  }

}
